/**
 * DevExtreme (esm/__internal/core/license/types.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var TokenKind;
! function(TokenKind) {
    TokenKind.corrupted = "corrupted";
    TokenKind.verified = "verified";
    TokenKind.internal = "internal"
}(TokenKind || (TokenKind = {}));
